export const TRANSLATION_SCOPE = 'surveyCodeModule';
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
